import { Trans } from '@lingui/macro'
import { Box, Divider, Grid, SxProps, Typography } from '@mui/material'
import { useAppContext } from 'app/hooks/useAppContext'
import { isNil } from 'lodash'
import React from 'react'
import { useLocation } from 'react-router'
import { CustomBackButton } from '../common-components/CustomButton'

export const PortalTabHeader: React.FC<{
  header: React.ReactNode | string
  description?: React.ReactNode | string
  actionButton?: React.ReactNode
  backButton?: boolean
  backButtonHref?: string
  sx?: SxProps
}> = ({ header, actionButton, description, sx, backButtonHref, backButton = false }) => {
  const { pathname } = useLocation()
  const { previousPath, previousName } = useAppContext()

  let isPreviousPath = true
  if (previousPath == null || pathname.includes(previousPath)) {
    isPreviousPath = false
  }

  return (
    <Box {...(!isNil(sx) && { sx })}>
      <Typography variant='h1'>
        {header}
      </Typography>
      {(header != null || actionButton != null) &&
        <Grid container sx={{ mb: '4px' }} justifyContent='space-between' wrap='nowrap'>
          <Grid item xs={8}>
            <Typography>
              {description}
            </Typography>
          </Grid>

          <Grid item xs={4} container justifyContent='flex-end'>
            <Grid item>
              {actionButton}
            </Grid>
          </Grid>
        </Grid>}
      {backButton && isPreviousPath &&
        <Box sx={{
          mt: '12px',
          mb: '8px'
        }}
        >
          <CustomBackButton href={backButtonHref ?? previousPath ?? '/'}>
            {previousName != null
              ? (
                <>
                  <Trans>FAQ_BACK_TO_LABEL</Trans>{' '}
                  {previousName}
                </>
                )
              : <Trans>FAQ_BACK_LABEL</Trans>}
          </CustomBackButton>
        </Box>}
      <Divider sx={{ mb: '12px' }} />
    </Box>
  )
}
